import { AuthToken } from '@cobliteam/api-lib';
import { Location } from '@cobliteam/common-types';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PUBLIC_ROUTES = [Location.LOGIN, Location.PASSWORD_RECOVERY, Location.TOKEN_VALIDATION, Location.PASSWORD_RESET, Location.MFA_CHALLENGE];

const useRedirectAfterLogin = () => {
  const location = useLocation();
  const session = useSessionStore((s) => s.session);
  const canConsumeRedirectOnCurrentPath = PUBLIC_ROUTES.includes(location.pathname as Location) || location.pathname === Location.EMPTY || location.pathname === Location.HOME;

  // Save the current URL to redirect back to after login.
  const saveUrlToRedirectAfterLogin = useCallback(() => {
    const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);
    const isAuthenticated = !!authToken || !!session;
    const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname as Location);
    const redirectUrl = sessionStorage.getItem('redirectUrl');

    if (!(redirectUrl || isAuthenticated || isPublicRoute)) {
      const currentLocation = location.pathname + location.search + location.hash;
      sessionStorage.setItem('redirectUrl', currentLocation);
    }
  }, [location.pathname, location.search, location.hash, session]);

  const redirectSessionStorage = () => {
    const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);
    const isAuthenticated = !!authToken || !!session;
    const redirectUrl = sessionStorage.getItem('redirectUrl');

    if (!(redirectUrl && isAuthenticated)) {
      return null;
    }

    if (canConsumeRedirectOnCurrentPath) {
      sessionStorage.removeItem('redirectUrl');
      return redirectUrl;
    }

    return null;
  };

  useEffect(() => {
    saveUrlToRedirectAfterLogin();
  }, [saveUrlToRedirectAfterLogin]);

  return {
    saveUrlToRedirectAfterLogin,
    redirectSessionStorage,
  };
};

export default useRedirectAfterLogin;
